/* eslint-disable react-hooks/exhaustive-deps */
// import { Download, Printer } from 'lucide-react';
import { Booking, doGetBooking } from '../services/booking.service';
import { useEffect, useState } from 'react';
import { currencyFormatter } from '../helpers/formatter';
import { doGetProject, Project, ShortUrl } from '../services/project.service';
import moment from 'moment';
import { doGetInvoice, Invoice } from '../services/invoice.service';

export default function InvoicePage({ projectId, shortUrl }: { projectId: string, shortUrl: ShortUrl }) {

  const [booking, setBooking] = useState<Booking | null>(null);
  const [project, setProject] = useState<Project | null>(null);
  const [invoice, setInvoice] = useState<Invoice | null>(null);

  useEffect(() => {
    fetchInvoice()
    fetchProject()
  }, [])

  useEffect(() => {
    fetchBooking()
  }, [invoice])

  function fetchInvoice() {
    doGetInvoice(shortUrl.refId).then((res) => {
      setInvoice(res as Invoice);
    })
  }

  function fetchBooking() {
    if (!invoice?.sourceId) return

    doGetBooking(invoice?.sourceId).then((res) => {
      setBooking(res as Booking);
    })
  }

  function fetchProject() {
    doGetProject(projectId).then((res) => {
      setProject(res as Project);
    })
  }

  // Calculate totals
  const subtotal = booking?.totalPrice || 0;
  const total = subtotal;

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-lg p-8">
        {/* Header */}
        <div className="flex justify-between items-start mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">INVOICE</h1>
            <p className="text-gray-600">#{invoice?.invoiceNumber}</p>
          </div>
          {/* <div className="flex gap-4">
            <button className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
              <Printer className="w-4 h-4" />
              Print
            </button>
            <button className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">
              <Download className="w-4 h-4" />
              Download
            </button>
          </div> */}
        </div>

        {/* Company and Client Info */}
        <div className="grid grid-cols-2 gap-8 mb-8">
          {/* Company Details */}
          <div>
            <h2 className="text-lg font-semibold text-gray-800 mb-4">From:</h2>
            <div className="text-gray-600">
              <p className="font-medium">{project?.name}</p>
              <p>{project?.address}</p>
              <p className="mt-2">{project?.contactEmail}</p>
              <p>{project?.contactNo}</p>
            </div>
          </div>

          {/* Client Details */}
          <div>
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Bill To:</h2>
            <div className="text-gray-600">
              <p className="font-medium">{booking?.customer?.name}</p>
              <p>{booking?.customer?.address}</p>
              <p className="mt-2">{booking?.customer?.email}</p>
              <p>{booking?.customer?.phoneNo}</p>
            </div>
          </div>
        </div>

        {/* Invoice Details */}
        <div className="grid grid-cols-2 gap-8 mb-8">
          <div>
            <p className="text-gray-600">
              <span className="font-medium">Invoice Date:</span> {moment(invoice?.createdAt).format('DD/MM/YYYY')}
            </p>
            {/* <p className="text-gray-600">
              <span className="font-medium">Due Date:</span> {booking?.reservationEndDateTime?.toLocaleDateString()}
            </p> */}
          </div>
        </div>

        {/* Items Table */}
        <div className="mb-8">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Description</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">Quantity</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">Amount</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {booking?.serviceJson?.map((item, index) => (
                <tr key={index}>
                  <td className="px-4 py-3 text-sm text-gray-600">{item.title}</td>
                  <td className="px-4 py-3 text-sm text-gray-600 text-right">{1}</td>
                  <td className="px-4 py-3 text-sm text-gray-600 text-right">{currencyFormatter(item.price)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Totals */}
        <div className="flex justify-end">
          <div className="w-64">
            <div className="flex justify-between py-2">
              <span className="text-gray-600">Subtotal:</span>
              <span className="text-gray-800">{currencyFormatter(subtotal)}</span>
            </div>
            <div className="flex justify-between py-2 border-t border-gray-200">
              <span className="font-medium text-gray-800">Total:</span>
              <span className="font-medium text-gray-800">{currencyFormatter(total)}</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-600 text-center">
            Thank you for your business!
          </p>
        </div>
      </div>
    </div>
  );
}